import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const orderInfoEdit = (id, storeId, orderId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/order-info', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const orderInfoEditAdmin = (id, storeId, orderId, data) => {
  return axios({
    method: "put",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/store/" +
      storeId +
      "/store-customer/" +
      id +
      "/order/" +
      orderId +
      "/order-info-by-admin", // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getCustomerOrderChargesInfo = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/charge-discount', // for android use
    headers: getHeaders(),
  });
};


export const postCustomerOrderChargesAdd = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/charge-discount', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const putCustomerOrderChargesInfoUpdate = (id, storeId, orderId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/charge-discount', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const B2BOrderInfoEditAPI = (id, storeId, challanId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/b2b/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/challan/' +
      challanId +
      '/challan-info', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};









